var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1450_9290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8794 43.2431C37.8178 43.2759 37.7495 43.2923 37.682 43.2923C37.602 43.2923 37.522 43.2693 37.4528 43.2242L30.7802 38.8806L30.7635 38.8814L30.7268 38.8833C30.4858 38.8959 30.2453 38.9084 30.0002 38.9084C22.161 38.9084 16.2502 34.1367 16.2502 27.8092C16.2502 21.4807 22.161 16.709 30.0002 16.709C37.8395 16.709 43.7502 21.4807 43.7502 27.8092C43.7502 31.9042 41.7462 35.1726 38.0986 37.0393V42.8822C38.0986 43.0323 38.0144 43.1717 37.8794 43.2431Z",
    fill: "#40A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1153 25.7718C30.7001 25.7718 31.2185 25.9002 31.6704 26.1572C32.1312 26.4053 32.4857 26.7598 32.7338 27.2205C32.9907 27.6813 33.1192 28.213 33.1192 28.8155C33.1192 29.4535 32.9686 30.0162 32.6673 30.5036C32.3749 30.9821 31.9496 31.3543 31.3913 31.6201C30.8419 31.8771 30.1995 32.0055 29.464 32.0055C28.8615 32.0055 28.2633 31.9081 27.6696 31.7131C27.0848 31.5182 26.6107 31.2612 26.2474 30.9422L26.912 29.4535C27.7538 30.065 28.6134 30.3707 29.4906 30.3707C30.5982 30.3707 31.1521 29.8789 31.1521 28.8953C31.1521 28.4257 31.0059 28.0579 30.7134 27.7921C30.4299 27.5174 30.04 27.38 29.5438 27.38C29.2336 27.38 28.9191 27.4376 28.6001 27.5528C28.2899 27.668 28.0108 27.8275 27.7627 28.0313H26.5797V22.4355H32.654V24.0305H28.6001V26.1439C29.0165 25.8958 29.5216 25.7718 30.1153 25.7718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1450_9290",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.639216 0 0 0 0 0.980392 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1450_9290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1450_9290",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteBlue);
export default __webpack_public_path__ + "static/media/icInviteBlue.09e87faf1d6485fc068bd1f03dabecbc.svg";
export { ForwardRef as ReactComponent };